import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SkillCard from "./SkillCard.js"
import javascript from "../assets/skills/javascript.svg"
import typescript from "../assets/skills/typescript.png"
import react from "../assets/skills/react.svg"
import angular from "../assets/skills/angular.png"
import tessalte from "../assets/skills/tessalte.png"
import redux from "../assets/skills/redux.png"
import tailwind from "../assets/skills/tailwind.svg"
import jest from "../assets/skills/jest.png"    
import enzyme from "../assets/skills/enzyme.jpg"
import git from "../assets/skills/git.svg"
import gitlab from "../assets/skills/gitlab.svg"
import html from "../assets/skills/html.svg"
import hr from "../assets/curve-hr.svg"

export default function Skills() {
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1
      };

    return (
        <div id="skills" className="mt-4 text-white">
            <h1 className="text-2xl font-bold">Skills</h1>
            <p className="font-light text-gray-400">Here are some of my skills</p>

            <div className="mt-4">
                <Slider {...settings}>
                <SkillCard name="javascript" experience="5 years" img={javascript} />
                <SkillCard name="typescript" experience="2 years" img={typescript} />
                <SkillCard name="react" experience="2.5 years" img={react} />
                <SkillCard name="angular" experience="2 years" img={angular} />
                <SkillCard name="tessalte" experience="2 years" img={tessalte} />
                <SkillCard name="redux" experience="2 years" img={redux} />
                <SkillCard name="jest" experience="2 years" img={jest} />
                <SkillCard name="enzyme" experience="2 years" img={enzyme} />
                <SkillCard name="HTML" experience="6 years" img={html} />
                <SkillCard name="tailwind" experience="0.5 years" img={tailwind} />
                <SkillCard name="git" experience="4 years" img={git} />
                <SkillCard name="gitlab" experience="1 years" img={gitlab} />
                </Slider>
            </div>
            <img src={hr} className="w-full mt-8 md:h-3" alt="hr" />
        </div>
    )
}